import React from "react";
import { Wallet, CreditCard, Bitcoin, Send } from "lucide-react";

/**
 * PaymentMethodIcon — visual icon for payment method keys.
 * Uses uploaded brand assets for paypal/venmo/cashapp + custom Bitcoin-style svg for crypto.
 */
const ICON_SRC = {
  paypal: "/brand/paypal.png",
  venmo: "/brand/venmo.png",
  cashapp: "/brand/cashapp.png",
};

export const PAYMENT_METHODS = [
  { key: "paypal", label: "PayPal" },
  { key: "venmo", label: "Venmo" },
  { key: "cashapp", label: "Cash App" },
  { key: "crypto", label: "Crypto" },
  { key: "bank", label: "Bank Transfer" },
];

export function PaymentMethodIcon({ method, size = 22, className = "" }) {
  const m = String(method || "").toLowerCase();
  const src = ICON_SRC[m];
  const dim = { width: size, height: size };
  if (src) {
    return (
      <img
        data-testid={`payment-icon-${m}`}
        src={src}
        alt={`${m} logo`}
        style={dim}
        className={`shrink-0 rounded-md object-contain ${className}`}
      />
    );
  }
  if (m === "crypto") {
    return (
      <span
        data-testid="payment-icon-crypto"
        style={dim}
        className={`relative inline-flex shrink-0 items-center justify-center rounded-md bg-black ring-1 ring-[#c8ff00]/40 shadow-[0_0_10px_rgba(200,255,0,0.18)] ${className}`}
      >
        <Bitcoin size={Math.max(10, Math.round(size * 0.62))} className="text-[#c8ff00]" strokeWidth={2.4} />
      </span>
    );
  }
  if (m === "bank") {
    return <CreditCard size={size} className={`text-zinc-300 ${className}`} data-testid="payment-icon-bank" />;
  }
  return <Wallet size={size} className={`text-zinc-400 ${className}`} data-testid="payment-icon-generic" />;
}

export function PaymentMethodChip({ method, selected = false, onClick, size = 18 }) {
  const label = (PAYMENT_METHODS.find((m) => m.key === method)?.label) || method;
  return (
    <button
      type="button"
      data-testid={`payment-chip-${method}${selected ? "-selected" : ""}`}
      onClick={onClick}
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold transition-all ${
        selected
          ? "border-[#c8ff00]/60 bg-[#c8ff00]/10 text-[#c8ff00] shadow-[0_0_10px_rgba(200,255,0,0.3)]"
          : "border-border/60 bg-background/60 text-zinc-300 hover:border-[#c8ff00]/40 hover:text-white"
      }`}
    >
      <PaymentMethodIcon method={method} size={size} />
      {label}
    </button>
  );
}
